import React from 'react';

import { Avatar } from '@/components/common';
import { Skeleton } from '@/components/memo';

import './DentistTilePlaceholder.css';

const DentistTilePlaceholder: React.FC = () => {
  return (
    <div className="dentist-tile-placeholder">
      <Avatar className="dentist-tile-placeholder__avatar" loading />
      <p className="dentist-tile-placeholder__name">
        <Skeleton className="dentist-tile-placeholder__skeleton" />
      </p>
    </div>
  );
};

export default DentistTilePlaceholder;
